
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '../src/style/Public Style.scss' // 导入公共样式，并应用到全局
import axios from 'axios' // 导入axios
import qs from 'qs' // 导入qs
// import VueResource from 'vue-resource'
import store from './store/index' // 全局引入store
// import cookie from 'vue-cookie'
import VueCookies from 'vue-cookies'
import Astrict from './astrict.js' // 导入超时的js文件
Vue.config.productionTip = false
Vue.prototype.$http = axios // 使用axios
Vue.prototype.$qs = qs // 使用qs,在需要的组件中通过this.$qs获取qs对象
// Vue.prototype.$cookie = cookie;
Vue.use(VueCookies)
Vue.use(Astrict) // 使用超时文件
// Vue.use(VueResource)
Vue.use(ElementUI) // 使用element ui


Vue.directive('title', { // 设置浏览器标题
  inserted: function (el, binding) {
    document.title = el.dataset.title
  }
})
// post请求 默认添加token
axios.interceptors.request.use(config => {
  let tk = VueCookies.get('token')
  if (tk !== null && config.method === 'post' && !(config.data instanceof FormData)) {
    let qs = require('qs')
    let localData = config.data
    if (typeof (localData) === 'string') {
      localData = qs.parse(localData)
    }
    if (localData['token'] == null || localData['token'] === 'undefined') {
      localData['token'] = tk
    }
    config.data = qs.stringify(localData)
  }
  return config
}, error => {
  // 对请求错误做些什么
  if (error.response.status == 401) {
    ElementUI.MessageBox('登录状态已过期，即将跳转至登录页', '提示', {
      confirmButtonText: '确定'
    }).then(() => {
      window.open('/#/','_self');
    })
  } else{
    return Promise.resolve(error.response)
  }
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  axios,
  store, // 使用store
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js